import { useAuth } from "@/hooks/use-auth";
import { isUltra, planHasFeature } from "@/lib/plans";

// Plano da loja ATUAL da sessão (Ultra é por loja). `/me` já devolve
// store.plan efetivo, então não há fetch extra.
export function useIsUltra(): boolean {
  const { user } = useAuth();
  return isUltra((user as { store?: { plan?: string } } | null | undefined)?.store?.plan);
}

// Pode USAR a feature: o plano dela (Ultra; Profissional para as de PRO_FEATURES) ou uma liberação válida (direito
// adquirido, whitelist, teste — o servidor já filtra as vencidas). O SELO não olha isto — ele marca o plano da
// feature pra todo mundo que não assina, justamente pra ninguém descobrir tarde demais.
export function useFeatureAllowed(feature: string): boolean {
  const { user } = useAuth();
  const store = (user as { store?: { plan?: string; featureGrants?: string[] } } | null | undefined)?.store;
  return planHasFeature(store?.plan, feature) || (store?.featureGrants || []).includes(feature);
}

/** A loja paga algum plano (o selo «Disponível no Profissional» aparece para quem não paga). */
export function useIsPaidPlan(): boolean {
  const { user } = useAuth();
  const plan = (user as { store?: { plan?: string } } | null | undefined)?.store?.plan;
  return plan === "profissional" || plan === "ultra";
}
